import type { Glyph } from "./types";

export const SearchFieldIcon: Glyph = (props) => (
  <svg
    viewBox="0 0 20 20"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    {...props}
  >
    <circle cx="8.5" cy="8.5" r="6" />
    <path d="m13 13 5 5" />
  </svg>
);

export default SearchFieldIcon;
